export const trackGtmEvent = (event) => {
	const gtm = useGtm()
	if (gtm && gtm.enabled()) {
		window.dataLayer?.push(event)
	}
}
